import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Waiting = ({ message, extra = null }) => {
  return (
    <div className="login-spinner">
      <div className="login-spinner-message">{message}</div>
      <FontAwesomeIcon
        icon={['fas', 'circle-notch']}
        spin
        size="5x"
        fixedWidth
        className="spinner-icon"
      />
      {extra}
    </div>
  )
}

export default Waiting
